import { Plugin, H5Player } from '@tencent/thumbplayer-h5';
import { __extends } from 'tslib';
import { txpHideClass, isMobile } from '@tencent/thumbplayer-plugin-utils';

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = ".txp_alert_info{background:rgba(0,0,0,.6);bottom:67px;color:#fff;font-size:13px;left:10px;line-height:24px;padding:2px 8px;position:absolute;text-align:left;-webkit-transition:bottom .15s ease;transition:bottom .15s ease;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;z-index:2}.txp_alert_info.txp_none{display:none}.txp_alert_info.ctrl_resize{bottom:107px}.txp_alert_info.ctrl_hide{bottom:20px}.txp_alert_info .txp_btn{-webkit-appearance:none;-moz-appearance:none;appearance:none;background:0 0;border:none;cursor:pointer;font-family:inherit;font-size:1em;outline:0 none;position:relative}.txp_alert_info .txp_btn.txp_btn_close{color:#fff;cursor:pointer;display:inline-block;height:24px;margin-left:3px;position:relative;vertical-align:top;width:14px}.txp_alert_info .txp_btn.txp_btn_close:hover{color:#ff6429}.txp_alert_info .txp_btn.txp_btn_close:hover:before{background:url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMiAxMiI+PHBhdGggZmlsbD0iI0ZGNzgwMCIgZD0ibTEwLjUgMTAtLjUuNS00LTQtNCA0LS41LS41IDQtNC00LTQgLjUtLjUgNCA0IDQtNCAuNS41LTQgNCA0IDR6Ii8+PC9zdmc+) 50% no-repeat}.txp_alert_info .txp_btn.txp_btn_close:before{background:url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMiAxMiI+PHBhdGggZmlsbD0iI2ZmZiIgZD0ibTEwLjUgMTAtLjUuNS00LTQtNCA0LS41LS41IDQtNC00LTQgLjUtLjUgNCA0IDQtNCAuNS41LTQgNCA0IDR6Ii8+PC9zdmc+) 50% no-repeat;-webkit-box-sizing:border-box;box-sizing:border-box;content:\"\";height:12px;left:0;margin:0;padding:0;position:absolute;text-indent:0;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%);width:12px}.txp_alert_info .txp_btn.txp_none{display:none}.txp_alert_info .txp_alert_content a,.txp_alert_info .txp_alert_content em{color:#ff6429;font-style:normal;font-weight:400;padding:0 1px}.txp_alert_info .txp_alert_content .txp_alert_text{display:inline}.txp_alert_info .txp_none{display:none}";
styleInject(css_248z);

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

/** 热点广播的事件 */
// eslint-disable-next-line @typescript-eslint/naming-convention
var HOTPOINT_EVENTS;
(function (HOTPOINT_EVENTS) {
    HOTPOINT_EVENTS["HOT_MOUSE_OVER"] = "ctrl:hotpoint-mouseover";
    HOTPOINT_EVENTS["HOT_MOUSE_MOVE"] = "ctrl:hotpoint-mousemove";
    HOTPOINT_EVENTS["HOT_MOUSE_OUT"] = "ctrl:hotpoint-mouseout";
})(HOTPOINT_EVENTS || (HOTPOINT_EVENTS = {}));
// eslint-disable-next-line @typescript-eslint/naming-convention
var CtrlbarPluginName = 'ctrlbar';
/** 控制栏插件上广播的事件 */
var CTRL_EVENTS = __assign(__assign({ 
    /** 全屏状态变化 */
    FULLSCREEN_CHANGE: 'windowFullscreenChange', 
    /** 进入/退出全屏错误 */
    FULLSCREEN_ERROR: 'fullscreenError', 
    /** 伪全屏全屏状态变化 */
    FAKE_FULLSCREEN_CHANGE: 'browserFullscreenChange', 
    /** 画中画状态改变 */
    PIP_CHANGE: 'pipChange', 
    /** 点击画中画按钮 */
    CLICK_PIPBTN: 'ctrl:click-pipbtn', 
    /** 点击下一集按钮 */
    CLICK_NEXTBTN: 'ctrl:click-nextbtn', 
    /** 点击播放按钮 */
    CLICK_PLAYBTN: 'ctrl:click-playbtn', 
    /** 点击重播 */
    CLICK_REPLAY: 'ctrl:click-replay', 
    /** 点击循环播放按钮 */
    CLICK_LOOP: 'ctrl:click-loop', 
    /** 点击多语言 */
    SET_LANGUAGE: 'ctrl:set-language', 
    /** 点击清晰度 */
    SET_LEVEL: 'ctrl:set-level', 
    /** 点击多音轨 */
    SET_AUDIO: 'ctrl:set-audio', 
    /** 点击倍速 */
    SET_PLAYRATE: 'ctrl:set-playrate', 
    /** 拖拽音量 */
    SET_VOLUME: 'ctrl:set-volume', 
    /** 移动端浮层切换显隐 */
    TOGGLE_OVERLAY: 'ctrl:toggle-overlay', 
    /** @deprecated 拼写有错误，建议使用 MOUSE_DOWN，后续将删除 */
    MOUSE_DONW: 'ctrl:progress-mousedown', 
    /** 进度条 mousedown */
    MOUSE_DOWN: 'ctrl:progress-mousedown', 
    /** 进度条mousemove */
    MOUSE_MOVE: 'ctrl:progress-mousemove', 
    /** 进度条mouseup */
    MOUSE_UP: 'ctrl:progress-mouseup', 
    /** 进度条展示 */
    SHOW: 'ctrl:show', 
    /** 进度条隐藏 */
    HIDE: 'ctrl:hide' }, HOTPOINT_EVENTS), { 
    /** @ignore 移动端点击时间彩蛋事件，仅内部使用 */
    TEST_EVENT: 'ctrl:inner-test-event', 
    /** 控制栏尺寸发生变化，在进入全屏/伪全屏时广播 */
    RESIZE: 'ctrl:resize', 
    /** 展示清晰度浮层 */
    SHOW_LEVELS: 'ctrl:show-levels', 
    /** 鼠标hover至进度条上 */
    HOVER_PROGRESS: 'ctrl:hover-progress' });
var CtrlSize;
(function (CtrlSize) {
    CtrlSize["LARGE"] = "large";
    CtrlSize["NORMAL"] = "normal";
})(CtrlSize || (CtrlSize = {}));
var PlayBtnStatus;
(function (PlayBtnStatus) {
    PlayBtnStatus["PAUSE"] = "pause";
    PlayBtnStatus["PLAY"] = "play";
    PlayBtnStatus["REPLAY"] = "replay";
    PlayBtnStatus["STOP"] = "stop";
})(PlayBtnStatus || (PlayBtnStatus = {}));

/* eslint-disable @typescript-eslint/naming-convention */
/** show默认展示3s */
var defaultShowTime = 3;
/** 控制栏隐藏时增加此类名 */
var classNameOnCtrlHide = 'ctrl_hide';
/** 控制栏resize时增加此类名 */
var classNameOnCtrlResize = 'ctrl_resize';
/** 插件名 */
var TipsPluginName = 'tips';
/** Tips 默认的 z-index 值 */
var defaultZIndex = 2;

var TipsPlugin = /** @class */ (function (_super) {
    __extends(TipsPlugin, _super);
    function TipsPlugin(player, config, extra) {
        var _this = _super.call(this, player, config, extra) || this;
        _this.showOptions = null;
        _this.persistedShowOptions = null;
        _this.hide = function (removePersisted) {
            if (removePersisted === void 0) { removePersisted = false; }
            if (removePersisted) {
                _this.persistedShowOptions = null;
            }
            _this.el.removeEventListener('click', _this.clickTips);
            _this.showOptions = null;
            _this.el.classList.add(txpHideClass);
            _this.emit(TipsEvents.Hide);
            if (_this.persistedShowOptions) {
                _this.show(_this.persistedShowOptions);
            }
        };
        _this.clickTips = function (e) {
            var _a;
            if (!_this.showOptions) {
                return;
            }
            var callbackName = (_a = e.target) === null || _a === void 0 ? void 0 : _a.dataset.callback;
            if (!callbackName) {
                return;
            }
            if (typeof _this.showOptions[callbackName] === 'function') {
                _this.showOptions[callbackName]();
            }
        };
        _this.prepareDOM();
        _this.initDOMVars();
        if (config.followCtrlbar !== false) {
            _this.followCtrlbar();
        }
        return _this;
    }
    TipsPlugin.prototype.destroy = function () {
        this.hide(true);
        _super.prototype.destroy.call(this);
    };
    /**
     * 显示tip文案，可传入文本或者配置项。
     * @example
     * ```ts
     * // 传入文案
     * tips.show('正在缓冲中...');
     *
     * // 传入配置项
     * tips.show({
     *  text: '已为您跳转播放',
     *  // 展示5秒
     *  time: 5,
     * })
     *
     * // 传入可执行的回调函数
     * tips.show({
     *  text: `可试看 ${timeStr}，去腾讯视频观看完整版 <a href="javascript:;" data-callback="jumpToPage">立即前往</a>`,
     *  jumpToPage: () => {
     *    location.href = 'v.qq.com';
     *  },
     *  time: -1,
     * });
     * ```
     * @param option
     */
    TipsPlugin.prototype.show = function (option) {
        var _a;
        var text;
        var showClose = false;
        var time = defaultShowTime;
        var zIndex = defaultZIndex;
        if (typeof option === 'string' || typeof option === 'number') {
            text = String(option);
        }
        else {
            text = option.text;
            showClose = !!option.showClose;
            time = option.time || defaultShowTime;
            zIndex = (_a = option.zIndex) !== null && _a !== void 0 ? _a : defaultZIndex;
            if (option.persist) {
                // 此处仅保留最后一个被添加的persisted tips
                this.persistedShowOptions = option;
                time = -1; // 持久化标签的tips也需要展示时长为永久
            }
            this.showOptions = option;
        }
        this.$text.innerHTML = text;
        this.$close.classList.toggle(txpHideClass, !showClose);
        this.el.addEventListener('click', this.clickTips);
        this.el.classList.remove(txpHideClass);
        this.el.style.zIndex = String(zIndex);
        clearTimeout(this.timeoutId);
        if (time !== -1) {
            this.timeoutId = window.setTimeout(this.hide, time * 1e3);
        }
        this.emit(TipsEvents.Show);
    };
    TipsPlugin.prototype.prepareDOM = function () {
        var container = this.player.container;
        var htmlStr = "<div class=\"txp_alert_content\">\n      <div class=\"txp_alert_text\"></div>\n      <button class=\"txp_btn txp_btn_close\" title=\"\u5173\u95ED\"></button>\n    </div>";
        var el = document.createElement('div');
        el.className = "txp_alert_info ".concat(txpHideClass);
        el.innerHTML = htmlStr;
        container.insertAdjacentElement('beforeend', el);
        this.el = el;
    };
    TipsPlugin.prototype.initDOMVars = function () {
        var _this = this;
        this.$text = this.el.querySelector('.txp_alert_content .txp_alert_text');
        this.$close = this.el.querySelector('.txp_btn_close');
        this.$close.addEventListener('click', function () {
            var _a;
            _this.hide((_a = _this.showOptions) === null || _a === void 0 ? void 0 : _a.persist);
        });
        // 略微适配下移动端
        if (isMobile) {
            this.el.style.bottom = '40px';
        }
    };
    TipsPlugin.prototype.followCtrlbar = function () {
        var _this = this;
        this.msg.on("pluginsetup:".concat(CtrlbarPluginName), function () {
            var ctrl = _this.player.plugins[CtrlbarPluginName];
            ctrl.on(CTRL_EVENTS.SHOW, function () {
                _this.el.classList.remove(classNameOnCtrlHide);
            });
            ctrl.on(CTRL_EVENTS.HIDE, function () {
                _this.el.classList.add(classNameOnCtrlHide);
            });
            ctrl.on(CTRL_EVENTS.RESIZE, function (_a) {
                var data = _a.data;
                _this.el.classList.toggle(classNameOnCtrlResize, data.size === CtrlSize.LARGE);
            });
        });
    };
    TipsPlugin.pluginName = TipsPluginName;
    return TipsPlugin;
}(Plugin));
var TipsEvents;
(function (TipsEvents) {
    TipsEvents["Show"] = "show";
    TipsEvents["Hide"] = "hide";
})(TipsEvents || (TipsEvents = {}));

H5Player.registerPlugin(TipsPlugin.pluginName, TipsPlugin);

export { TipsEvents, TipsPlugin };
